import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CaseloadService } from "../../Services/CaseloadService";
import { StudentService } from "../../Services/StudentService";
import { UserService } from "../../Services/UserService";
import { ICaseload } from "../../Models/ICaseload";
import { ISelectedStudent } from '../../Models/ISelectedStudent';
import { IProviderCaseload } from '../../Models/IProviderCaseload';
import { INonProviderCaseload } from '../../Models/INonProviderCaseload';
import { Globals } from '../../globals';
import { Message } from 'primeng/primeng';
import { ISubstituteServiceProvider } from '../../Models/ISubstituteServiceProvider';

@Component({
  selector: 'dashboard',
  templateUrl: './MyDashboard.component.html',
})
export class MyDashboardComponent implements OnInit {
  _baseUrl: string;
  _myGlobals: Globals;
  _caseloadService: CaseloadService;
  _studentService: StudentService;
  _userService: UserService;
  errorMessages: any[] = [];
  messages: Message[];
  showSpinner: boolean = false;
  isServiceProvider: boolean = false;
  isSiteAdminClerical: boolean = false;
  isSysAdminSELPA: boolean = false;
  selectedProviderCaseload: IProviderCaseload;
  selectedNonProviderCaseload: INonProviderCaseload;
  substituteServiceProviderArray: ISubstituteServiceProvider[] = [];
  providerCaseloadArray: IProviderCaseload[] = [];
  nonProviderCaseloadArray: INonProviderCaseload[] = [];
  selectedSubstitute: ISubstituteServiceProvider;

  constructor(
    globals: Globals,
    @Inject('BASE_URL') baseUrl: string,
    caseloadService: CaseloadService,
    studentService: StudentService,
    userService: UserService
  ) {
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this._caseloadService = caseloadService;
    this._studentService = studentService;
    this._userService = userService;
  }

  ngOnInit(): void {
    this.populateCaseloadTable();

    this.isServiceProvider = false;
    this.isSiteAdminClerical = false;
    this.isSysAdminSELPA = false;

    switch (this._myGlobals.spedSecurityUser.roleName) {
      case "Clerical":
      case "SiteAdministrator":
        this.isSiteAdminClerical = true;
        break;
      case "SELPA":
      case "SysAdmin":
        this.isSysAdminSELPA = true;
        break;
      case "Provider":
        this.isServiceProvider = true;
        break;
    }

    if (this._myGlobals.spedSecurityUser.roleName == "Provider") {
      this._userService.getSubstituteServiceProviders(this._myGlobals.spedSecurityUser.id).subscribe((res: ISubstituteServiceProvider[]) => {
        this.substituteServiceProviderArray = res;
      },
        err => console.error(err)
      );
    }
  }

  populateCaseloadTable() {
    if (this._myGlobals.spedSecurityUser.roleName == "Provider") {
      this._caseloadService.getProviderCaseloadList().subscribe((res: IProviderCaseload[]) => {
        this.providerCaseloadArray = res
      },
        err => console.error(err)
      );
    }
    else if (this._myGlobals.spedSecurityUser.roleName == "SiteAdministrator" || this._myGlobals.spedSecurityUser.roleName == "Clerical") {
      this._caseloadService.getAdministratorClerkCaseloadList().subscribe((res: IProviderCaseload[]) => {
        this.providerCaseloadArray = res
      },
        err => console.error(err)
      );
    }
    else if (this._myGlobals.spedSecurityUser.roleName == "SELPA" || this._myGlobals.spedSecurityUser.roleName == "SysAdmin") {
      this._caseloadService.getSELPASysAdminCaseloadList().subscribe((res: INonProviderCaseload[]) => {
        this.nonProviderCaseloadArray = res
      },
        err => console.error(err)
      );
    }
  }

  onRowSelect(event) {
    this._studentService.get(this._baseUrl + 'api/Student/' + this.selectedProviderCaseload.localStudentId).subscribe((res: ISelectedStudent) => {
      this._myGlobals.setSelectedStudent(res),
        this._myGlobals.studentSearchIsVisible = false,
        this._myGlobals.initialIepInfoIsVisible = false,
        window.scrollTo(0, 0),
        console.log(this._myGlobals.selectedStudent)
    },
      err => console.error(err)
    );
  }

  onSysAdninSELPARowSelect(event) {
    this._studentService.get(this._baseUrl + 'api/Student/' + this.selectedNonProviderCaseload.localStudentId).subscribe((res: ISelectedStudent) => {
      this._myGlobals.setSelectedStudent(res),
        this._myGlobals.studentSearchIsVisible = false,
        this._myGlobals.initialIepInfoIsVisible = false,
        window.scrollTo(0, 0),
        console.log(this._myGlobals.selectedStudent)
    },
      err => console.error(err)
    );
  }
  
  sustituteSelected(event) {
    if (event.data != null) {
      this.selectedSubstitute = event.data as ISubstituteServiceProvider;
      this._userService.startSubstituting(this.selectedSubstitute.substituteServiceProviderId).subscribe((res: ISubstituteServiceProvider) => {
        this._myGlobals.substitutingForServiceProvider = res as ISubstituteServiceProvider;
        this.populateCaseloadTable();
      },
        err => console.error(err)
      );

    }
  }

  stopSubstituting() {
    this._myGlobals.substitutingForServiceProvider = null;
    this._userService.stopSubstituting().subscribe(() => {
      this.populateCaseloadTable();
    },
      err => console.error(err)
    );

  }


  onRowUnselect(event) {

  }

}
